/**
 * @module emojis/emojislist
 */
import { Plugin } from 'ckeditor5/src/core';

export default class EmojisList extends Plugin {
    /**
     * @inheritDoc
     */
    static get pluginName() {
        return 'EmojisList';
    }
    /**
     * @inheritDoc
     */
    init() {
        const editor = this.editor;
        const t = editor.t;
        const plugin = editor.plugins.get('Emojis');
        Object.keys(emojisGroupLabels).forEach((groupKey) => {
            var emojislist = emojisList.filter((data) => data.group === groupKey);
            if(emojislist.length) {
                emojisList.forEach(emoji => {
                    emoji.title = t(emoji.title);
                });
                plugin.addItems(emojisGroupLabels[groupKey], emojislist, { label: t(emojisGroupLabels[groupKey]) })
            }
        });
    }
}

const emojisGroupLabels = {
    p: 'Emojis, People & emotions',
    a: 'Activities & events',
    n: 'Animals & nature',
    o: 'Objects',
    s: 'Symbols',
    f: 'Food',
    t: 'Travel places',
    fl: 'Flags'
};
const emojisList = [
    {
        title: 'Grinning Face',
        group: 'p',
        emoji: '😀'
    },
    {
        title: 'Grinning Face with Big Eyes',
        group: 'p',
        emoji: '😃'
    },
    {
        title: 'Grinning Face with Smiling Eyes',
        group: 'p',
        emoji: '😄'
    },
    {
        title: 'Beaming Face with Smiling Eyes',
        group: 'p',
        emoji: '😁'
    },
    {
        title: 'Grinning Squinting Face',
        group: 'p',
        emoji: '😆'
    },
    {
        title: 'Grinning Face with Sweat',
        group: 'p',
        emoji: '😅'
    },
    {
        title: 'Face with Tears of Joy',
        group: 'p',
        emoji: '😂'
    },
    {
        title: 'Slightly Smiling Face',
        group: 'p',
        emoji: '🙂'
    },
    {
        title: 'Winking Face',
        emoji: '😉',
        group: 'p'
    },
    {
        title: 'Smiling Face with Smiling Eyes',
        emoji: '😊',
        group: 'p'
    },
    {
        title: 'Smiling Face with Halo',
        emoji: '😇',
        group: 'p'
    },
    {
        title: 'Smiling Face with Heart-Eyes',
        emoji: '😍',
        group: 'p'
    },
    {
        title: 'Face Blowing a Kiss',
        emoji: '😘',
        group: 'p'
    },
    {
        title: 'Kissing Face',
        emoji: '😗',
        group: 'p'
    },
    {
        title: 'Kissing Face with Closed Eyes',
        emoji: '😚',
        group: 'p'
    },
    {
        title: 'Kissing Face with Smiling Eyes',
        emoji: '😙',
        group: 'p'
    },
    {
        title: 'Face Savoring Food',
        emoji: '😋',
        group: 'p'
    },
    {
        title: 'Face with Tongue',
        emoji: '😛',
        group: 'p'
    },
    {
        title: 'Winking Face with Tongue',
        emoji: '😜',
        group: 'p'
    },
    {
        title: 'Squinting Face with Tongue',
        emoji: '😝',
        group: 'p'
    },
    {
        title: 'Neutral Face',
        emoji: '😐',
        group: 'p'
    },
    {
        title: 'Expressionless Face',
        emoji: '😑',
        group: 'p'
    },
    {
        title: 'Face Without Mouth',
        emoji: '😶',
        group: 'p'
    },
    {
        title: 'Smirking Face',
        emoji: '😏',
        group: 'p'
    },
    {
        title: 'Unamused Face',
        emoji: '😒',
        group: 'p'
    },
    {
        title: 'Grimacing Face',
        emoji: '😬',
        group: 'p'
    },
    {
        title: 'Relieved Face',
        emoji: '😌',
        group: 'p'
    },
    {
        title: 'Pensive Face',
        emoji: '😔',
        group: 'p'
    },
    {
        title: 'Sleepy Face',
        emoji: '😪',
        group: 'p'
    },
    {
        title: 'Sleeping Face',
        emoji: '😴',
        group: 'p'
    },
    {
        title: 'Face with Medical Mask',
        emoji: '😷',
        group: 'p'
    },
    {
        title: 'Face with Crossed-Out Eyes',
        emoji: '😵',
        group: 'p'
    },
    {
        title: 'Smiling Face with Sunglasses',
        emoji: '😎',
        group: 'p'
    },
    {
        title: 'Confused Face',
        emoji: '😕',
        group: 'p'
    },
    {
        title: 'Worried Face',
        emoji: '😟',
        group: 'p'
    },
    {
        title: 'Face with Open Mouth',
        emoji: '😮',
        group: 'p'
    },
    {
        title: 'Hushed Face',
        emoji: '😯',
        group: 'p'
    },
    {
        title: 'Astonished Face',
        emoji: '😲',
        group: 'p'
    },
    {
        title: 'Flushed Face',
        emoji: '😳',
        group: 'p'
    },
    {
        title: 'Frowning Face with Open Mouth',
        emoji: '😦',
        group: 'p'
    },
    {
        title: 'Anguished Face',
        emoji: '😧',
        group: 'p'
    },
    {
        title: 'Fearful Face',
        emoji: '😨',
        group: 'p'
    },
    {
        title: 'Anxious Face with Sweat',
        emoji: '😰',
        group: 'p'
    },
    {
        title: 'Sad but Relieved Face',
        emoji: '😥',
        group: 'p'
    },
    {
        title: 'Crying Face',
        emoji: '😢',
        group: 'p'
    },
    {
        title: 'Loudly Crying Face',
        emoji: '😭',
        group: 'p'
    },
    {
        title: 'Face Screaming in Fear',
        emoji: '😱',
        group: 'p'
    },
    {
        title: 'Confounded Face',
        emoji: '😖',
        group: 'p'
    },
    {
        title: 'Persevering Face',
        emoji: '😣',
        group: 'p'
    },
    {
        title: 'Disappointed Face',
        emoji: '😞',
        group: 'p'
    },
    {
        title: 'Downcast Face with Sweat',
        emoji: '😓',
        group: 'p'
    },
    {
        title: 'Weary Face',
        emoji: '😩',
        group: 'p'
    },
    {
        title: 'Tired Face',
        emoji: '😫',
        group: 'p'
    },
    {
        title: 'Face with Steam From Nose',
        emoji: '😤',
        group: 'p'
    },
    {
        title: 'Enraged Face',
        emoji: '😡',
        group: 'p'
    },
    {
        title: 'Angry Face',
        emoji: '😠',
        group: 'p'
    },
    {
        title: 'Smiling Face with Horns',
        emoji: '😈',
        group: 'p'
    },
    {
        title: 'Angry Face with Horns',
        emoji: '👿',
        group: 'p'
    },
    {
        title: 'Skull',
        group: 'p',
        emoji: '💀'
    },
    {
        title: 'Pile of Poo',
        emoji: '💩',
        group: 'p'
    },
    {
        title: 'Ogre',
        group: 'p',
        emoji: '👹'
    },
    {
        title: 'Goblin',
        group: 'p',
        emoji: '👺'
    },
    {
        title: 'Ghost',
        group: 'p',
        emoji: '👻'
    },
    {
        title: 'Alien',
        group: 'p',
        emoji: '👽'
    },
    {
        title: 'Alien Monster',
        emoji: '👾',
        group: 'p'
    },
    {
        title: 'Grinning Cat',
        emoji: '😺',
        group: 'p'
    },
    {
        title: 'Grinning Cat with Smiling Eyes',
        emoji: '😸',
        group: 'p'
    },
    {
        title: 'Cat with Tears of Joy',
        emoji: '😹',
        group: 'p'
    },
    {
        title: 'Smiling Cat with Heart-Eyes',
        emoji: '😻',
        group: 'p'
    },
    {
        title: 'Cat with Wry Smile',
        emoji: '😼',
        group: 'p'
    },
    {
        title: 'Kissing Cat',
        emoji: '😽',
        group: 'p'
    },
    {
        title: 'Weary Cat',
        emoji: '🙀',
        group: 'p'
    },
    {
        title: 'Crying Cat',
        emoji: '😿',
        group: 'p'
    },
    {
        title: 'Pouting Cat',
        emoji: '😾',
        group: 'p'
    },
    {
        title: 'See-No-Evil Monkey',
        emoji: '🙈',
        group: 'n'
    },
    {
        title: 'Hear-No-Evil Monkey',
        emoji: '🙉',
        group: 'n'
    },
    {
        title: 'Speak-No-Evil Monkey',
        emoji: '🙊',
        group: 'n'
    },
    {
        title: 'Kiss Mark',
        emoji: '💋',
        group: 'p'
    },
    {
        title: 'Love Letter',
        emoji: '💌',
        group: 'o'
    },
    {
        title: 'Heart with Arrow',
        emoji: '💘',
        group: 's'
    },
    {
        title: 'Heart with Ribbon',
        emoji: '💝',
        group: 's'
    },
    {
        title: 'Sparkling Heart',
        emoji: '💖',
        group: 's'
    },
    {
        title: 'Growing Heart',
        emoji: '💗',
        group: 's'
    },
    {
        title: 'Beating Heart',
        emoji: '💓',
        group: 's'
    },
    {
        title: 'Revolving Hearts',
        emoji: '💞',
        group: 's'
    },
    {
        title: 'Two Hearts',
        emoji: '💕',
        group: 's'
    },
    {
        title: 'Heart Decoration',
        emoji: '💟',
        group: 's'
    },
    {
        title: 'Broken Heart',
        emoji: '💔',
        group: 's'
    },
    {
        title: 'Red Heart',
        emoji: '❤️',
        group: 's'
    },
    {
        title: 'Yellow Heart',
        emoji: '💛',
        group: 's'
    },
    {
        title: 'Green Heart',
        emoji: '💚',
        group: 's'
    },
    {
        title: 'Blue Heart',
        emoji: '💙',
        group: 's'
    },
    {
        title: 'Purple Heart',
        emoji: '💜',
        group: 's'
    },
    {
        title: 'Hundred Points',
        emoji: '💯',
        group: 's'
    },
    {
        title: 'Anger Symbol',
        emoji: '💢',
        group: 's'
    },
    {
        title: 'Collision',
        emoji: '💥',
        group: 'n'
    },
    {
        title: 'Dizzy',
        group: 'n',
        emoji: '💫'
    },
    {
        title: 'Sweat Droplets',
        emoji: '💦',
        group: 'n'
    },
    {
        title: 'Dashing Away',
        emoji: '💨',
        group: 'n'
    },
    {
        title: 'Bomb',
        group: 'o',
        emoji: '💣'
    },
    {
        title: 'Speech Balloon',
        emoji: '💬',
        group: 's'
    },
    {
        title: 'Thought Balloon',
        emoji: '💭',
        group: 's'
    },
    {
        title: 'Zzz',
        group: 's',
        emoji: '💤'
    },
    {
        title: 'Waving Hand',
        emoji: '👋',
        group: 'p'
    },
    {
        title: 'Raised Hand',
        emoji: '✋',
        group: 'p'
    },
    {
        title: 'OK Hand',
        emoji: '👌',
        group: 'p'
    },
    {
        title: 'Victory Hand',
        emoji: '✌️',
        group: 'p'
    },
    {
        title: 'Backhand Index Pointing Left',
        emoji: '👈',
        group: 'p'
    },
    {
        title: 'Backhand Index Pointing Right',
        emoji: '👉',
        group: 'p'
    },
    {
        title: 'Backhand Index Pointing Up',
        emoji: '👆',
        group: 'p'
    },
    {
        title: 'Backhand Index Pointing Down',
        emoji: '👇',
        group: 'p'
    },
    {
        title: 'Index Pointing Up',
        emoji: '☝️',
        group: 'p'
    },
    {
        title: 'Thumbs Up',
        emoji: '👍',
        group: 'p'
    },
    {
        title: 'Thumbs Down',
        emoji: '👎',
        group: 'p'
    },
    {
        title: 'Raised Fist',
        emoji: '✊',
        group: 'p'
    },
    {
        title: 'Oncoming Fist',
        emoji: '👊',
        group: 'p'
    },
    {
        title: 'Clapping Hands',
        emoji: '👏',
        group: 'p'
    },
    {
        title: 'Raising Hands',
        emoji: '🙌',
        group: 'p'
    },
    {
        title: 'Open Hands',
        emoji: '👐',
        group: 'p'
    },
    {
        title: 'Folded Hands',
        emoji: '🙏',
        group: 'p'
    },
    {
        title: 'Nail Polish',
        emoji: '💅',
        group: 'p'
    },
    {
        title: 'Flexed Biceps',
        emoji: '💪',
        group: 'p'
    },
    {
        title: 'Ear',
        group: 'p',
        emoji: '👂'
    },
    {
        title: 'Nose',
        group: 'p',
        emoji: '👃'
    },
    {
        title: 'Eyes',
        group: 'p',
        emoji: '👀'
    },
    {
        title: 'Tongue',
        emoji: '👅',
        group: 'p'
    },
    {
        title: 'Mouth',
        group: 'p',
        emoji: '👄'
    },
    {
        title: 'Baby',
        group: 'p',
        emoji: '👶'
    },
    {
        title: 'Boy',
        group: 'p',
        emoji: '👦'
    },
    {
        title: 'Girl',
        group: 'p',
        emoji: '👧'
    },
    {
        title: 'Person: Blond Hair',
        emoji: '👱',
        group: 'p'
    },
    {
        title: 'Man',
        group: 'p',
        emoji: '👨'
    },
    {
        title: 'Woman',
        group: 'p',
        emoji: '👩'
    },
    {
        title: 'Old Man',
        emoji: '👴',
        group: 'p'
    },
    {
        title: 'Old Woman',
        emoji: '👵',
        group: 'p'
    },
    {
        title: 'Person Frowning',
        emoji: '🙍',
        group: 'p'
    },
    {
        title: 'Person Pouting',
        emoji: '🙎',
        group: 'p'
    },
    {
        title: 'Person Gesturing No',
        emoji: '🙅',
        group: 'p'
    },
    {
        title: 'Person Gesturing OK',
        emoji: '🙆',
        group: 'p'
    },
    {
        title: 'Person Tipping Hand',
        emoji: '💁',
        group: 'p'
    },
    {
        title: 'Person Raising Hand',
        emoji: '🙋',
        group: 'p'
    },
    {
        title: 'Person Bowing',
        emoji: '🙇',
        group: 'p'
    },
    {
        title: 'Police Officer',
        emoji: '👮',
        group: 'p'
    },
    {
        title: 'Guard',
        group: 'p',
        emoji: '💂'
    },
    {
        title: 'Construction Worker',
        emoji: '👷',
        group: 'p'
    },
    {
        title: 'Princess',
        emoji: '👸',
        group: 'p'
    },
    {
        title: 'Person Wearing Turban',
        emoji: '👳',
        group: 'p'
    },
    {
        title: 'Person with Skullcap',
        emoji: '👲',
        group: 'p'
    },
    {
        title: 'Person with Veil',
        emoji: '👰',
        group: 'p'
    },
    {
        title: 'Baby Angel',
        emoji: '👼',
        group: 'p'
    },
    {
        title: 'Santa Claus',
        emoji: '🎅',
        group: 'p'
    },
    {
        title: 'Person Getting Massage',
        emoji: '💆',
        group: 'p'
    },
    {
        title: 'Person Getting Haircut',
        emoji: '💇',
        group: 'p'
    },
    {
        title: 'Person Walking',
        emoji: '🚶',
        group: 'p'
    },
    {
        title: 'Person Running',
        emoji: '🏃',
        group: 'p'
    },
    {
        title: 'Woman Dancing',
        emoji: '💃',
        group: 'p'
    },
    {
        title: 'People with Bunny Ears',
        emoji: '👯',
        group: 'p'
    },
    {
        title: 'Horse Racing',
        emoji: '🏇',
        group: 'a'
    },
    {
        title: 'Snowboarder',
        emoji: '🏂',
        group: 'a'
    },
    {
        title: 'Person Surfing',
        emoji: '🏄',
        group: 'a'
    },
    {
        title: 'Person Rowing Boat',
        emoji: '🚣',
        group: 'a'
    },
    {
        title: 'Person Swimming',
        emoji: '🏊',
        group: 'a'
    },
    {
        title: 'Person Biking',
        emoji: '🚴',
        group: 'a'
    },
    {
        title: 'Person Mountain Biking',
        emoji: '🚵',
        group: 'a'
    },
    {
        title: 'Person Taking Bath',
        emoji: '🛀',
        group: 'o'
    },
    {
        title: 'Women Holding Hands',
        emoji: '👭',
        group: 'p'
    },
    {
        title: 'Woman and Man Holding Hands',
        emoji: '👫',
        group: 'p'
    },
    {
        title: 'Men Holding Hands',
        emoji: '👬',
        group: 'p'
    },
    {
        title: 'Kiss',
        group: 'p',
        emoji: '💏'
    },
    {
        title: 'Kiss: Man, Man',
        emoji: '👨‍❤️‍💋‍👨',
        group: 'p'
    },
    {
        title: 'Kiss: Woman, Woman',
        emoji: '👩‍❤️‍💋‍👩',
        group: 'p'
    },
    {
        title: 'Couple with Heart',
        emoji: '💑',
        group: 'p'
    },
    {
        title: 'Couple with Heart: Man, Man',
        emoji: '👨‍❤️‍👨',
        group: 'p'
    },
    {
        title: 'Couple with Heart: Woman, Woman',
        emoji: '👩‍❤️‍👩',
        group: 'p'
    },
    {
        title: 'Family',
        emoji: '👪',
        group: 'p'
    },
    {
        title: 'Family: Man, Woman, Girl',
        emoji: '👨‍👩‍👧',
        group: 'p'
    },
    {
        title: 'Family: Man, Woman, Girl, Boy',
        emoji: '👨‍👩‍👧‍👦',
        group: 'p'
    },
    {
        title: 'Family: Man, Woman, Boy, Boy',
        emoji: '👨‍👩‍👦‍👦',
        group: 'p'
    },
    {
        title: 'Family: Man, Woman, Girl, Girl',
        emoji: '👨‍👩‍👧‍👧',
        group: 'p'
    },
    {
        title: 'Family: Man, Man, Boy',
        emoji: '👨‍👨‍👦',
        group: 'p'
    },
    {
        title: 'Family: Man, Man, Girl',
        emoji: '👨‍👨‍👧',
        group: 'p'
    },
    {
        title: 'Family: Man, Man, Girl, Boy',
        emoji: '👨‍👨‍👧‍👦',
        group: 'p'
    },
    {
        title: 'Family: Man, Man, Boy, Boy',
        emoji: '👨‍👨‍👦‍👦',
        group: 'p'
    },
    {
        title: 'Family: Man, Man, Girl, Girl',
        emoji: '👨‍👨‍👧‍👧',
        group: 'p'
    },
    {
        title: 'Family: Woman, Woman, Boy',
        emoji: '👩‍👩‍👦',
        group: 'p'
    },
    {
        title: 'Family: Woman, Woman, Girl',
        emoji: '👩‍👩‍👧',
        group: 'p'
    },
    {
        title: 'Family: Woman, Woman, Girl, Boy',
        emoji: '👩‍👩‍👧‍👦',
        group: 'p'
    },
    {
        title: 'Family: Woman, Woman, Boy, Boy',
        emoji: '👩‍👩‍👦‍👦',
        group: 'p'
    },
    {
        title: 'Family: Woman, Woman, Girl, Girl',
        emoji: '👩‍👩‍👧‍👧',
        group: 'p'
    },
    {
        title: 'Bust in Silhouette',
        emoji: '👤',
        group: 'p'
    },
    {
        title: 'Busts in Silhouette',
        emoji: '👥',
        group: 'p'
    },
    {
        title: 'Footprints',
        emoji: '👣',
        group: 'p'
    },
    {
        title: 'Monkey Face',
        emoji: '🐵',
        group: 'n'
    },
    {
        title: 'Monkey',
        emoji: '🐒',
        group: 'n'
    },
    {
        title: 'Dog Face',
        emoji: '🐶',
        group: 'n'
    },
    {
        title: 'Dog',
        group: 'n',
        emoji: '🐕'
    },
    {
        title: 'Poodle',
        emoji: '🐩',
        group: 'n'
    },
    {
        title: 'Wolf',
        group: 'n',
        emoji: '🐺'
    },
    {
        title: 'Cat Face',
        emoji: '🐱',
        group: 'n'
    },
    {
        title: 'Cat',
        group: 'n',
        emoji: '🐈'
    },
    {
        title: 'Tiger Face',
        emoji: '🐯',
        group: 'n'
    },
    {
        title: 'Tiger',
        group: 'n',
        emoji: '🐅'
    },
    {
        title: 'Leopard',
        emoji: '🐆',
        group: 'n'
    },
    {
        title: 'Horse Face',
        emoji: '🐴',
        group: 'n'
    },
    {
        title: 'Horse',
        group: 'n',
        emoji: '🐎'
    },
    {
        title: 'Cow Face',
        emoji: '🐮',
        group: 'n'
    },
    {
        title: 'Ox',
        group: 'n',
        emoji: '🐂'
    },
    {
        title: 'Water Buffalo',
        emoji: '🐃',
        group: 'n'
    },
    {
        title: 'Cow',
        group: 'n',
        emoji: '🐄'
    },
    {
        title: 'Pig Face',
        emoji: '🐷',
        group: 'n'
    },
    {
        title: 'Pig',
        group: 'n',
        emoji: '🐖'
    },
    {
        title: 'Boar',
        group: 'n',
        emoji: '🐗'
    },
    {
        title: 'Pig Nose',
        emoji: '🐽',
        group: 'n'
    },
    {
        title: 'Ram',
        group: 'n',
        emoji: '🐏'
    },
    {
        title: 'Ewe',
        group: 'n',
        emoji: '🐑'
    },
    {
        title: 'Goat',
        group: 'n',
        emoji: '🐐'
    },
    {
        title: 'Camel',
        group: 'n',
        emoji: '🐪'
    },
    {
        title: 'Two-Hump Camel',
        emoji: '🐫',
        group: 'n'
    },
    {
        title: 'Elephant',
        emoji: '🐘',
        group: 'n'
    },
    {
        title: 'Mouse Face',
        emoji: '🐭',
        group: 'n'
    },
    {
        title: 'Mouse',
        group: 'n',
        emoji: '🐁'
    },
    {
        title: 'Rat',
        group: 'n',
        emoji: '🐀'
    },
    {
        title: 'Hamster',
        emoji: '🐹',
        group: 'n'
    },
    {
        title: 'Rabbit Face',
        emoji: '🐰',
        group: 'n'
    },
    {
        title: 'Rabbit',
        emoji: '🐇',
        group: 'n'
    },
    {
        title: 'Bear',
        group: 'n',
        emoji: '🐻'
    },
    {
        title: 'Koala',
        group: 'n',
        emoji: '🐨'
    },
    {
        title: 'Panda',
        group: 'n',
        emoji: '🐼'
    },
    {
        title: 'Paw Prints',
        emoji: '🐾',
        group: 'n'
    },
    {
        title: 'Chicken',
        emoji: '🐔',
        group: 'n'
    },
    {
        title: 'Rooster',
        emoji: '🐓',
        group: 'n'
    },
    {
        title: 'Hatching Chick',
        emoji: '🐣',
        group: 'n'
    },
    {
        title: 'Baby Chick',
        emoji: '🐤',
        group: 'n'
    },
    {
        title: 'Front-Facing Baby Chick',
        emoji: '🐥',
        group: 'n'
    },
    {
        title: 'Bird',
        group: 'n',
        emoji: '🐦'
    },
    {
        title: 'Penguin',
        emoji: '🐧',
        group: 'n'
    },
    {
        title: 'Frog',
        group: 'n',
        emoji: '🐸'
    },
    {
        title: 'Crocodile',
        emoji: '🐊',
        group: 'n'
    },
    {
        title: 'Turtle',
        emoji: '🐢',
        group: 'n'
    },
    {
        title: 'Snake',
        group: 'n',
        emoji: '🐍'
    },
    {
        title: 'Dragon Face',
        emoji: '🐲',
        group: 'n'
    },
    {
        title: 'Dragon',
        emoji: '🐉',
        group: 'n'
    },
    {
        title: 'Spouting Whale',
        emoji: '🐳',
        group: 'n'
    },
    {
        title: 'Whale',
        group: 'n',
        emoji: '🐋'
    },
    {
        title: 'Dolphin',
        emoji: '🐬',
        group: 'n'
    },
    {
        title: 'Fish',
        group: 'n',
        emoji: '🐟'
    },
    {
        title: 'Tropical Fish',
        emoji: '🐠',
        group: 'n'
    },
    {
        title: 'Blowfish',
        emoji: '🐡',
        group: 'n'
    },
    {
        title: 'Octopus',
        emoji: '🐙',
        group: 'n'
    },
    {
        title: 'Spiral Shell',
        emoji: '🐚',
        group: 'n'
    },
    {
        title: 'Snail',
        group: 'n',
        emoji: '🐌'
    },
    {
        title: 'Bug',
        group: 'n',
        emoji: '🐛'
    },
    {
        title: 'Ant',
        group: 'n',
        emoji: '🐜'
    },
    {
        title: 'Honeybee',
        emoji: '🐝',
        group: 'n'
    },
    {
        title: 'Lady Beetle',
        emoji: '🐞',
        group: 'n'
    },
    {
        title: 'Bouquet',
        emoji: '💐',
        group: 'n'
    },
    {
        title: 'Cherry Blossom',
        emoji: '🌸',
        group: 'n'
    },
    {
        title: 'White Flower',
        emoji: '💮',
        group: 'n'
    },
    {
        title: 'Rose',
        group: 'n',
        emoji: '🌹'
    },
    {
        title: 'Hibiscus',
        emoji: '🌺',
        group: 'n'
    },
    {
        title: 'Sunflower',
        emoji: '🌻',
        group: 'n'
    },
    {
        title: 'Blossom',
        emoji: '🌼',
        group: 'n'
    },
    {
        title: 'Tulip',
        group: 'n',
        emoji: '🌷'
    },
    {
        title: 'Seedling',
        emoji: '🌱',
        group: 'n'
    },
    {
        title: 'Evergreen Tree',
        emoji: '🌲',
        group: 'n'
    },
    {
        title: 'Deciduous Tree',
        emoji: '🌳',
        group: 'n'
    },
    {
        title: 'Palm Tree',
        emoji: '🌴',
        group: 'n'
    },
    {
        title: 'Cactus',
        emoji: '🌵',
        group: 'n'
    },
    {
        title: 'Sheaf of Rice',
        emoji: '🌾',
        group: 'n'
    },
    {
        title: 'Herb',
        group: 'n',
        emoji: '🌿'
    },
    {
        title: 'Four Leaf Clover',
        emoji: '🍀',
        group: 'n'
    },
    {
        title: 'Maple Leaf',
        emoji: '🍁',
        group: 'n'
    },
    {
        title: 'Fallen Leaf',
        emoji: '🍂',
        group: 'n'
    },
    {
        title: 'Leaf Fluttering in Wind',
        emoji: '🍃',
        group: 'n'
    },
    {
        title: 'Grapes',
        group: 'f',
        emoji: '🍇'
    },
    {
        title: 'Melon',
        group: 'f',
        emoji: '🍈'
    },
    {
        title: 'Watermelon',
        emoji: '🍉',
        group: 'f'
    },
    {
        title: 'Tangerine',
        emoji: '🍊',
        group: 'f'
    },
    {
        title: 'Lemon',
        group: 'f',
        emoji: '🍋'
    },
    {
        title: 'Banana',
        group: 'f',
        emoji: '🍌'
    },
    {
        title: 'Pineapple',
        emoji: '🍍',
        group: 'f'
    },
    {
        title: 'Red Apple',
        emoji: '🍎',
        group: 'f'
    },
    {
        title: 'Green Apple',
        emoji: '🍏',
        group: 'f'
    },
    {
        title: 'Pear',
        group: 'f',
        emoji: '🍐'
    },
    {
        title: 'Peach',
        group: 'f',
        emoji: '🍑'
    },
    {
        title: 'Cherries',
        emoji: '🍒',
        group: 'f'
    },
    {
        title: 'Strawberry',
        emoji: '🍓',
        group: 'f'
    },
    {
        title: 'Tomato',
        group: 'f',
        emoji: '🍅'
    },
    {
        title: 'Eggplant',
        emoji: '🍆',
        group: 'f'
    },
    {
        title: 'Ear of Corn',
        emoji: '🌽',
        group: 'f'
    },
    {
        title: 'Mushroom',
        emoji: '🍄',
        group: 'n'
    },
    {
        title: 'Chestnut',
        emoji: '🌰',
        group: 'n'
    },
    {
        title: 'Bread',
        group: 'f',
        emoji: '🍞'
    },
    {
        title: 'Meat on Bone',
        emoji: '🍖',
        group: 'f'
    },
    {
        title: 'Poultry Leg',
        emoji: '🍗',
        group: 'f'
    },
    {
        title: 'Hamburger',
        emoji: '🍔',
        group: 'f'
    },
    {
        title: 'French Fries',
        emoji: '🍟',
        group: 'f'
    },
    {
        title: 'Pizza',
        group: 'f',
        emoji: '🍕'
    },
    {
        title: 'Cooking',
        emoji: '🍳',
        group: 'f'
    },
    {
        title: 'Pot of Food',
        emoji: '🍲',
        group: 'f'
    },
    {
        title: 'Bento Box',
        emoji: '🍱',
        group: 'f'
    },
    {
        title: 'Rice Cracker',
        emoji: '🍘',
        group: 'f'
    },
    {
        title: 'Rice Ball',
        emoji: '🍙',
        group: 'f'
    },
    {
        title: 'Cooked Rice',
        emoji: '🍚',
        group: 'f'
    },
    {
        title: 'Curry Rice',
        emoji: '🍛',
        group: 'f'
    },
    {
        title: 'Steaming Bowl',
        emoji: '🍜',
        group: 'f'
    },
    {
        title: 'Spaghetti',
        emoji: '🍝',
        group: 'f'
    },
    {
        title: 'Roasted Sweet Potato',
        emoji: '🍠',
        group: 'f'
    },
    {
        title: 'Oden',
        group: 'f',
        emoji: '🍢'
    },
    {
        title: 'Sushi',
        group: 'f',
        emoji: '🍣'
    },
    {
        title: 'Fried Shrimp',
        emoji: '🍤',
        group: 'f'
    },
    {
        title: 'Fish Cake with Swirl',
        emoji: '🍥',
        group: 'f'
    },
    {
        title: 'Dango',
        group: 'f',
        emoji: '🍡'
    },
    {
        title: 'Soft Ice Cream',
        emoji: '🍦',
        group: 'f'
    },
    {
        title: 'Shaved Ice',
        emoji: '🍧',
        group: 'f'
    },
    {
        title: 'Ice Cream',
        emoji: '🍨',
        group: 'f'
    },
    {
        title: 'Doughnut',
        emoji: '🍩',
        group: 'f'
    },
    {
        title: 'Cookie',
        group: 'f',
        emoji: '🍪'
    },
    {
        title: 'Birthday Cake',
        emoji: '🎂',
        group: 'f'
    },
    {
        title: 'Shortcake',
        emoji: '🍰',
        group: 'f'
    },
    {
        title: 'Chocolate Bar',
        emoji: '🍫',
        group: 'f'
    },
    {
        title: 'Candy',
        group: 'f',
        emoji: '🍬'
    },
    {
        title: 'Lollipop',
        emoji: '🍭',
        group: 'f'
    },
    {
        title: 'Custard',
        emoji: '🍮',
        group: 'f'
    },
    {
        title: 'Honey Pot',
        emoji: '🍯',
        group: 'f'
    },
    {
        title: 'Baby Bottle',
        emoji: '🍼',
        group: 'f'
    },
    {
        title: 'Hot Beverage',
        emoji: '☕',
        group: 'f'
    },
    {
        title: 'Teacup Without Handle',
        emoji: '🍵',
        group: 'f'
    },
    {
        title: 'Sake',
        group: 'f',
        emoji: '🍶'
    },
    {
        title: 'Wine Glass',
        emoji: '🍷',
        group: 'f'
    },
    {
        title: 'Cocktail Glass',
        emoji: '🍸',
        group: 'f'
    },
    {
        title: 'Tropical Drink',
        emoji: '🍹',
        group: 'f'
    },
    {
        title: 'Beer Mug',
        emoji: '🍺',
        group: 'f'
    },
    {
        title: 'Clinking Beer Mugs',
        emoji: '🍻',
        group: 'f'
    },
    {
        title: 'Fork and Knife',
        emoji: '🍴',
        group: 'f'
    },
    {
        title: 'Kitchen Knife',
        emoji: '🔪',
        group: 'o'
    },
    {
        title: 'Globe Showing Europe-Africa',
        emoji: '🌍',
        group: 'n'
    },
    {
        title: 'Globe Showing Americas',
        emoji: '🌎',
        group: 'n'
    },
    {
        title: 'Globe Showing Asia-Australia',
        emoji: '🌏',
        group: 'n'
    },
    {
        title: 'Globe with Meridians',
        emoji: '🌐',
        group: 'n'
    },
    {
        title: 'Map of Japan',
        emoji: '🗾',
        group: 't'
    },
    {
        title: 'Volcano',
        emoji: '🌋',
        group: 't'
    },
    {
        title: 'Mount Fuji',
        emoji: '🗻',
        group: 't'
    },
    {
        title: 'House',
        emoji: '🏠',
        group: 't'
    },
    {
        title: 'House with Garden',
        emoji: '🏡',
        group: 't'
    },
    {
        title: 'Office Building',
        emoji: '🏢',
        group: 't'
    },
    {
        title: 'Japanese Post Office',
        emoji: '🏣',
        group: 't'
    },
    {
        title: 'Post Office',
        emoji: '🏤',
        group: 't'
    },
    {
        title: 'Hospital',
        emoji: '🏥',
        group: 't'
    },
    {
        title: 'Bank',
        emoji: '🏦',
        group: 't'
    },
    {
        title: 'Hotel',
        emoji: '🏨',
        group: 't'
    },
    {
        title: 'Love Hotel',
        emoji: '🏩',
        group: 't'
    },
    {
        title: 'Convenience Store',
        emoji: '🏪',
        group: 't'
    },
    {
        title: 'School',
        emoji: '🏫',
        group: 't'
    },
    {
        title: 'Department Store',
        emoji: '🏬',
        group: 't'
    },
    {
        title: 'Factory',
        emoji: '🏭',
        group: 't'
    },
    {
        title: 'Japanese Castle',
        emoji: '🏯',
        group: 't'
    },
    {
        title: 'Castle',
        emoji: '🏰',
        group: 't'
    },
    {
        title: 'Wedding',
        emoji: '💒',
        group: 't'
    },
    {
        title: 'Tokyo Tower',
        emoji: '🗼',
        group: 't'
    },
    {
        title: 'Statue of Liberty',
        emoji: '🗽',
        group: 't'
    },
    {
        title: 'Church',
        emoji: '⛪',
        group: 't'
    },
    {
        title: 'Fountain',
        emoji: '⛲',
        group: 't'
    },
    {
        title: 'Tent',
        emoji: '⛺',
        group: 't'
    },
    {
        title: 'Foggy',
        emoji: '🌁',
        group: 't'
    },
    {
        title: 'Night with Stars',
        emoji: '🌃',
        group: 't'
    },
    {
        title: 'Sunrise Over Mountains',
        emoji: '🌄',
        group: 't'
    },
    {
        title: 'Sunrise',
        emoji: '🌅',
        group: 't'
    },
    {
        title: 'Cityscape at Dusk',
        emoji: '🌆',
        group: 't'
    },
    {
        title: 'Sunset',
        emoji: '🌇',
        group: 't'
    },
    {
        title: 'Bridge at Night',
        emoji: '🌉',
        group: 't'
    },
    {
        title: 'Hot Springs',
        emoji: '♨️',
        group: 's'
    },
    {
        title: 'Carousel Horse',
        emoji: '🎠',
        group: 't'
    },
    {
        title: 'Ferris Wheel',
        emoji: '🎡',
        group: 't'
    },
    {
        title: 'Roller Coaster',
        emoji: '🎢',
        group: 't'
    },
    {
        title: 'Barber Pole',
        emoji: '💈',
        group: 'o'
    },
    {
        title: 'Circus Tent',
        emoji: '🎪',
        group: 'a'
    },
    {
        title: 'Locomotive',
        emoji: '🚂',
        group: 't'
    },
    {
        title: 'Railway Car',
        emoji: '🚃',
        group: 't'
    },
    {
        title: 'High-Speed Train',
        emoji: '🚄',
        group: 't'
    },
    {
        title: 'Bullet Train',
        emoji: '🚅',
        group: 't'
    },
    {
        title: 'Train',
        emoji: '🚆',
        group: 't'
    },
    {
        title: 'Metro',
        emoji: '🚇',
        group: 't'
    },
    {
        title: 'Light Rail',
        emoji: '🚈',
        group: 't'
    },
    {
        title: 'Station',
        emoji: '🚉',
        group: 't'
    },
    {
        title: 'Tram',
        emoji: '🚊',
        group: 't'
    },
    {
        title: 'Monorail',
        emoji: '🚝',
        group: 't'
    },
    {
        title: 'Mountain Railway',
        emoji: '🚞',
        group: 't'
    },
    {
        title: 'Tram Car',
        emoji: '🚋',
        group: 't'
    },
    {
        title: 'Bus',
        emoji: '🚌',
        group: 't'
    },
    {
        title: 'Oncoming Bus',
        emoji: '🚍',
        group: 't'
    },
    {
        title: 'Trolleybus',
        emoji: '🚎',
        group: 't'
    },
    {
        title: 'Minibus',
        emoji: '🚐',
        group: 't'
    },
    {
        title: 'Ambulance',
        emoji: '🚑',
        group: 't'
    },
    {
        title: 'Fire Engine',
        emoji: '🚒',
        group: 't'
    },
    {
        title: 'Police Car',
        emoji: '🚓',
        group: 't'
    },
    {
        title: 'Oncoming Police Car',
        emoji: '🚔',
        group: 't'
    },
    {
        title: 'Taxi',
        emoji: '🚕',
        group: 't'
    },
    {
        title: 'Oncoming Taxi',
        emoji: '🚖',
        group: 't'
    },
    {
        title: 'Automobile',
        emoji: '🚗',
        group: 't'
    },
    {
        title: 'Oncoming Automobile',
        emoji: '🚘',
        group: 't'
    },
    {
        title: 'Sport Utility Vehicle',
        emoji: '🚙',
        group: 't'
    },
    {
        title: 'Delivery Truck',
        emoji: '🚚',
        group: 't'
    },
    {
        title: 'Articulated Lorry',
        emoji: '🚛',
        group: 't'
    },
    {
        title: 'Tractor',
        emoji: '🚜',
        group: 't'
    },
    {
        title: 'Bicycle',
        emoji: '🚲',
        group: 't'
    },
    {
        title: 'Bus Stop',
        emoji: '🚏',
        group: 't'
    },
    {
        title: 'Fuel Pump',
        emoji: '⛽',
        group: 't'
    },
    {
        title: 'Police Car Light',
        emoji: '🚨',
        group: 't'
    },
    {
        title: 'Horizontal Traffic Light',
        emoji: '🚥',
        group: 't'
    },
    {
        title: 'Vertical Traffic Light',
        emoji: '🚦',
        group: 't'
    },
    {
        title: 'Construction',
        emoji: '🚧',
        group: 't'
    },
    {
        title: 'Anchor',
        emoji: '⚓',
        group: 't'
    },
    {
        title: 'Sailboat',
        emoji: '⛵',
        group: 't'
    },
    {
        title: 'Speedboat',
        emoji: '🚤',
        group: 't'
    },
    {
        title: 'Ship',
        emoji: '🚢',
        group: 't'
    },
    {
        title: 'Airplane',
        emoji: '✈️',
        group: 't'
    },
    {
        title: 'Seat',
        emoji: '💺',
        group: 't'
    },
    {
        title: 'Helicopter',
        emoji: '🚁',
        group: 't'
    },
    {
        title: 'Suspension Railway',
        emoji: '🚟',
        group: 't'
    },
    {
        title: 'Mountain Cableway',
        emoji: '🚠',
        group: 't'
    },
    {
        title: 'Aerial Tramway',
        emoji: '🚡',
        group: 't'
    },
    {
        title: 'Rocket',
        emoji: '🚀',
        group: 't'
    },
    {
        title: 'Hourglass Done',
        emoji: '⌛',
        group: 'o'
    },
    {
        title: 'Hourglass Not Done',
        emoji: '⏳',
        group: 'o'
    },
    {
        title: 'Watch',
        group: 'o',
        emoji: '⌚'
    },
    {
        title: 'Alarm Clock',
        emoji: '⏰',
        group: 'o'
    },
    {
        title: 'Twelve O’Clock',
        emoji: '🕛',
        group: 's'
    },
    {
        title: 'Twelve-Thirty',
        emoji: '🕧',
        group: 's'
    },
    {
        title: 'One O’Clock',
        emoji: '🕐',
        group: 's'
    },
    {
        title: 'One-Thirty',
        emoji: '🕜',
        group: 's'
    },
    {
        title: 'Two O’Clock',
        emoji: '🕑',
        group: 's'
    },
    {
        title: 'Two-Thirty',
        emoji: '🕝',
        group: 's'
    },
    {
        title: 'Three O’Clock',
        emoji: '🕒',
        group: 's'
    },
    {
        title: 'Three-Thirty',
        emoji: '🕞',
        group: 's'
    },
    {
        title: 'Four O’Clock',
        emoji: '🕓',
        group: 's'
    },
    {
        title: 'Four-Thirty',
        emoji: '🕟',
        group: 's'
    },
    {
        title: 'Five O’Clock',
        emoji: '🕔',
        group: 's'
    },
    {
        title: 'Five-Thirty',
        emoji: '🕠',
        group: 's'
    },
    {
        title: 'Six O’Clock',
        emoji: '🕕',
        group: 's'
    },
    {
        title: 'Six-Thirty',
        emoji: '🕡',
        group: 's'
    },
    {
        title: 'Seven O’Clock',
        emoji: '🕖',
        group: 's'
    },
    {
        title: 'Seven-Thirty',
        emoji: '🕢',
        group: 's'
    },
    {
        title: 'Eight O’Clock',
        emoji: '🕗',
        group: 's'
    },
    {
        title: 'Eight-Thirty',
        emoji: '🕣',
        group: 's'
    },
    {
        title: 'Nine O’Clock',
        emoji: '🕘',
        group: 's'
    },
    {
        title: 'Nine-Thirty',
        emoji: '🕤',
        group: 's'
    },
    {
        title: 'Ten O’Clock',
        emoji: '🕙',
        group: 's'
    },
    {
        title: 'Ten-Thirty',
        emoji: '🕥',
        group: 's'
    },
    {
        title: 'Eleven O’Clock',
        emoji: '🕚',
        group: 's'
    },
    {
        title: 'Eleven-Thirty',
        emoji: '🕦',
        group: 's'
    },
    {
        title: 'New Moon',
        emoji: '🌑',
        group: 'n'
    },
    {
        title: 'Waxing Crescent Moon',
        emoji: '🌒',
        group: 'n'
    },
    {
        title: 'First Quarter Moon',
        emoji: '🌓',
        group: 'n'
    },
    {
        title: 'Waxing Gibbous Moon',
        emoji: '🌔',
        group: 'n'
    },
    {
        title: 'Full Moon',
        emoji: '🌕',
        group: 'n'
    },
    {
        title: 'Waning Gibbous Moon',
        emoji: '🌖',
        group: 'n'
    },
    {
        title: 'Last Quarter Moon',
        emoji: '🌗',
        group: 'n'
    },
    {
        title: 'Waning Crescent Moon',
        emoji: '🌘',
        group: 'n'
    },
    {
        title: 'Crescent Moon',
        emoji: '🌙',
        group: 'n'
    },
    {
        title: 'New Moon Face',
        emoji: '🌚',
        group: 'n'
    },
    {
        title: 'First Quarter Moon Face',
        emoji: '🌛',
        group: 'n'
    },
    {
        title: 'Last Quarter Moon Face',
        emoji: '🌜',
        group: 'n'
    },
    {
        title: 'Sun',
        group: 'n',
        emoji: '☀️'
    },
    {
        title: 'Full Moon Face',
        emoji: '🌝',
        group: 'n'
    },
    {
        title: 'Sun with Face',
        emoji: '🌞',
        group: 'n'
    },
    {
        title: 'Star',
        group: 'n',
        emoji: '⭐'
    },
    {
        title: 'Glowing Star',
        emoji: '🌟',
        group: 'n'
    },
    {
        title: 'Shooting Star',
        emoji: '🌠',
        group: 'n'
    },
    {
        title: 'Milky Way',
        emoji: '🌌',
        group: 't'
    },
    {
        title: 'Cloud',
        group: 'n',
        emoji: '☁️'
    },
    {
        title: 'Sun Behind Cloud',
        emoji: '⛅',
        group: 'n'
    },
    {
        title: 'Cyclone',
        emoji: '🌀',
        group: 's'
    },
    {
        title: 'Rainbow',
        emoji: '🌈',
        group: 'n'
    },
    {
        title: 'Closed Umbrella',
        emoji: '🌂',
        group: 'p'
    },
    {
        title: 'Umbrella with Rain Drops',
        emoji: '☔',
        group: 'n'
    },
    {
        title: 'High Voltage',
        emoji: '⚡',
        group: 'n'
    },
    {
        title: 'Snowflake',
        emoji: '❄️',
        group: 'n'
    },
    {
        title: 'Snowman Without Snow',
        emoji: '⛄',
        group: 'n'
    },
    {
        title: 'Fire',
        group: 'n',
        emoji: '🔥'
    },
    {
        title: 'Droplet',
        emoji: '💧',
        group: 'n'
    },
    {
        title: 'Water Wave',
        emoji: '🌊',
        group: 'n'
    },
    {
        title: 'Jack-O-Lantern',
        emoji: '🎃',
        group: 'p'
    },
    {
        title: 'Christmas Tree',
        emoji: '🎄',
        group: 'n'
    },
    {
        title: 'Fireworks',
        emoji: '🎆',
        group: 't'
    },
    {
        title: 'Sparkler',
        emoji: '🎇',
        group: 't'
    },
    {
        title: 'Sparkles',
        emoji: '✨',
        group: 'n'
    },
    {
        title: 'Balloon',
        emoji: '🎈',
        group: 'o'
    },
    {
        title: 'Party Popper',
        emoji: '🎉',
        group: 'o'
    },
    {
        title: 'Confetti Ball',
        emoji: '🎊',
        group: 'o'
    },
    {
        title: 'Tanabata Tree',
        emoji: '🎋',
        group: 'n'
    },
    {
        title: 'Pine Decoration',
        emoji: '🎍',
        group: 'n'
    },
    {
        title: 'Japanese Dolls',
        emoji: '🎎',
        group: 'o'
    },
    {
        title: 'Carp Streamer',
        emoji: '🎏',
        group: 'o'
    },
    {
        title: 'Wind Chime',
        emoji: '🎐',
        group: 'o'
    },
    {
        title: 'Moon Viewing Ceremony',
        emoji: '🎑',
        group: 't'
    },
    {
        title: 'Ribbon',
        emoji: '🎀',
        group: 'o'
    },
    {
        title: 'Wrapped Gift',
        emoji: '🎁',
        group: 'o'
    },
    {
        title: 'Ticket',
        emoji: '🎫',
        group: 'a'
    },
    {
        title: 'Trophy',
        emoji: '🏆',
        group: 'a'
    },
    {
        title: 'Soccer Ball',
        emoji: '⚽',
        group: 'a'
    },
    {
        title: 'Baseball',
        emoji: '⚾',
        group: 'a'
    },
    {
        title: 'Basketball',
        emoji: '🏀',
        group: 'a'
    },
    {
        title: 'American Football',
        emoji: '🏈',
        group: 'a'
    },
    {
        title: 'Rugby Football',
        emoji: '🏉',
        group: 'a'
    },
    {
        title: 'Tennis',
        emoji: '🎾',
        group: 'a'
    },
    {
        title: 'Bowling',
        emoji: '🎳',
        group: 'a'
    },
    {
        title: 'Flag in Hole',
        emoji: '⛳',
        group: 'a'
    },
    {
        title: 'Fishing Pole',
        emoji: '🎣',
        group: 'a'
    },
    {
        title: 'Running Shirt',
        emoji: '🎽',
        group: 'a'
    },
    {
        title: 'Skis',
        group: 'a',
        emoji: '🎿'
    },
    {
        title: 'Bullseye',
        emoji: '🎯',
        group: 'a'
    },
    {
        title: 'Pool 8 Ball',
        group: 'a',
        emoji: '🎱'
    },
    {
        title: 'Crystal Ball',
        emoji: '🔮',
        group: 'o'
    },
    {
        title: 'Video Game',
        emoji: '🎮',
        group: 'a'
    },
    {
        title: 'Slot Machine',
        emoji: '🎰',
        group: 'a'
    },
    {
        title: 'Game Die',
        emoji: '🎲',
        group: 'a'
    },
    {
        title: 'Joker',
        group: 's',
        emoji: '🃏'
    },
    {
        title: 'Mahjong Red Dragon',
        emoji: '🀄',
        group: 's'
    },
    {
        title: 'Flower Playing Cards',
        emoji: '🎴',
        group: 's'
    },
    {
        title: 'Performing Arts',
        emoji: '🎭',
        group: 'a'
    },
    {
        title: 'Artist Palette',
        emoji: '🎨',
        group: 'a'
    },
    {
        title: 'Glasses',
        emoji: '👓',
        group: 'p'
    },
    {
        title: 'Necktie',
        emoji: '👔',
        group: 'p'
    },
    {
        title: 'T-Shirt',
        emoji: '👕',
        group: 'p'
    },
    {
        title: 'Jeans',
        group: 'p',
        emoji: '👖'
    },
    {
        title: 'Dress',
        group: 'p',
        emoji: '👗'
    },
    {
        title: 'Kimono',
        emoji: '👘',
        group: 'p'
    },
    {
        title: 'Bikini',
        emoji: '👙',
        group: 'p'
    },
    {
        title: 'Woman’s Clothes',
        emoji: '👚',
        group: 'p'
    },
    {
        title: 'Purse',
        group: 'p',
        emoji: '👛'
    },
    {
        title: 'Handbag',
        emoji: '👜',
        group: 'p'
    },
    {
        title: 'Clutch Bag',
        emoji: '👝',
        group: 'p'
    },
    {
        title: 'Backpack',
        emoji: '🎒',
        group: 'p'
    },
    {
        title: 'Man’s Shoe',
        emoji: '👞',
        group: 'p'
    },
    {
        title: 'Running Shoe',
        emoji: '👟',
        group: 'p'
    },
    {
        title: 'High-Heeled Shoe',
        emoji: '👠',
        group: 'p'
    },
    {
        title: 'Woman’s Sandal',
        emoji: '👡',
        group: 'p'
    },
    {
        title: 'Woman’s Boot',
        emoji: '👢',
        group: 'p'
    },
    {
        title: 'Crown',
        group: 'p',
        emoji: '👑'
    },
    {
        title: 'Woman’s Hat',
        emoji: '👒',
        group: 'p'
    },
    {
        title: 'Top Hat',
        emoji: '🎩',
        group: 'p'
    },
    {
        title: 'Graduation Cap',
        emoji: '🎓',
        group: 'p'
    },
    {
        title: 'Lipstick',
        emoji: '💄',
        group: 'p'
    },
    {
        title: 'Ring',
        group: 'p',
        emoji: '💍'
    },
    {
        title: 'Gem Stone',
        emoji: '💎',
        group: 'o'
    },
    {
        title: 'Muted Speaker',
        emoji: '🔇',
        group: 's'
    },
    {
        title: 'Speaker Low Volume',
        emoji: '🔈',
        group: 's'
    },
    {
        title: 'Speaker Medium Volume',
        emoji: '🔉',
        group: 's'
    },
    {
        title: 'Speaker High Volume',
        emoji: '🔊',
        group: 's'
    },
    {
        title: 'Loudspeaker',
        emoji: '📢',
        group: 's'
    },
    {
        title: 'Megaphone',
        emoji: '📣',
        group: 's'
    },
    {
        title: 'Postal Horn',
        emoji: '📯',
        group: 'o'
    },
    {
        title: 'Bell',
        group: 's',
        emoji: '🔔'
    },
    {
        title: 'Bell with Slash',
        emoji: '🔕',
        group: 's'
    },
    {
        title: 'Musical Score',
        emoji: '🎼',
        group: 'a'
    },
    {
        title: 'Musical Note',
        emoji: '🎵',
        group: 's'
    },
    {
        title: 'Musical Notes',
        emoji: '🎶',
        group: 's'
    },
    {
        title: 'Microphone',
        emoji: '🎤',
        group: 'a'
    },
    {
        title: 'Headphone',
        emoji: '🎧',
        group: 'a'
    },
    {
        title: 'Radio',
        group: 'o',
        emoji: '📻'
    },
    {
        title: 'Saxophone',
        emoji: '🎷',
        group: 'a'
    },
    {
        title: 'Guitar',
        emoji: '🎸',
        group: 'a'
    },
    {
        title: 'Musical Keyboard',
        emoji: '🎹',
        group: 'a'
    },
    {
        title: 'Trumpet',
        emoji: '🎺',
        group: 'a'
    },
    {
        title: 'Violin',
        emoji: '🎻',
        group: 'a'
    },
    {
        title: 'Mobile Phone',
        emoji: '📱',
        group: 'o'
    },
    {
        title: 'Mobile Phone with Arrow',
        emoji: '📲',
        group: 'o'
    },
    {
        title: 'Telephone',
        emoji: '☎️',
        group: 'o'
    },
    {
        title: 'Telephone Receiver',
        emoji: '📞',
        group: 'o'
    },
    {
        title: 'Pager',
        group: 'o',
        emoji: '📟'
    },
    {
        title: 'Fax Machine',
        emoji: '📠',
        group: 'o'
    },
    {
        title: 'Battery',
        emoji: '🔋',
        group: 'o'
    },
    {
        title: 'Electric Plug',
        emoji: '🔌',
        group: 'o'
    },
    {
        title: 'Laptop',
        emoji: '💻',
        group: 'o'
    },
    {
        title: 'Computer Disk',
        emoji: '💽',
        group: 'o'
    },
    {
        title: 'Floppy Disk',
        emoji: '💾',
        group: 'o'
    },
    {
        title: 'Optical Disk',
        emoji: '💿',
        group: 'o'
    },
    {
        title: 'DVD',
        group: 'o',
        emoji: '📀'
    },
    {
        title: 'Movie Camera',
        emoji: '🎥',
        group: 'o'
    },
    {
        title: 'Clapper Board',
        emoji: '🎬',
        group: 'a'
    },
    {
        title: 'Television',
        emoji: '📺',
        group: 'o'
    },
    {
        title: 'Camera',
        emoji: '📷',
        group: 'o'
    },
    {
        title: 'Video Camera',
        emoji: '📹',
        group: 'o'
    },
    {
        title: 'Videocassette',
        emoji: '📼',
        group: 'o'
    },
    {
        title: 'Magnifying Glass Tilted Left',
        emoji: '🔍',
        group: 'o'
    },
    {
        title: 'Magnifying Glass Tilted Right',
        emoji: '🔎',
        group: 'o'
    },
    {
        title: 'Light Bulb',
        emoji: '💡',
        group: 'o'
    },
    {
        title: 'Flashlight',
        emoji: '🔦',
        group: 'o'
    },
    {
        title: 'Red Paper Lantern',
        emoji: '🏮',
        group: 'o'
    },
    {
        title: 'Notebook with Decorative Cover',
        emoji: '📔',
        group: 'o'
    },
    {
        title: 'Closed Book',
        emoji: '📕',
        group: 'o'
    },
    {
        title: 'Open Book',
        emoji: '📖',
        group: 'o'
    },
    {
        title: 'Green Book',
        emoji: '📗',
        group: 'o'
    },
    {
        title: 'Blue Book',
        emoji: '📘',
        group: 'o'
    },
    {
        title: 'Orange Book',
        emoji: '📙',
        group: 'o'
    },
    {
        title: 'Books',
        group: 'o',
        emoji: '📚'
    },
    {
        title: 'Notebook',
        emoji: '📓',
        group: 'o'
    },
    {
        title: 'Ledger',
        emoji: '📒',
        group: 'o'
    },
    {
        title: 'Page with Curl',
        emoji: '📃',
        group: 'o'
    },
    {
        title: 'Scroll',
        emoji: '📜',
        group: 'o'
    },
    {
        title: 'Page Facing Up',
        emoji: '📄',
        group: 'o'
    },
    {
        title: 'Newspaper',
        emoji: '📰',
        group: 'o'
    },
    {
        title: 'Bookmark Tabs',
        emoji: '📑',
        group: 'o'
    },
    {
        title: 'Bookmark',
        emoji: '🔖',
        group: 'o'
    },
    {
        title: 'Money Bag',
        emoji: '💰',
        group: 'o'
    },
    {
        title: 'Yen Banknote',
        emoji: '💴',
        group: 'o'
    },
    {
        title: 'Dollar Banknote',
        emoji: '💵',
        group: 'o'
    },
    {
        title: 'Euro Banknote',
        emoji: '💶',
        group: 'o'
    },
    {
        title: 'Pound Banknote',
        emoji: '💷',
        group: 'o'
    },
    {
        title: 'Money with Wings',
        emoji: '💸',
        group: 'o'
    },
    {
        title: 'Credit Card',
        emoji: '💳',
        group: 'o'
    },
    {
        title: 'Chart Increasing with Yen',
        emoji: '💹',
        group: 's'
    },
    {
        title: 'Envelope',
        emoji: '✉️',
        group: 'o'
    },
    {
        title: 'E-Mail',
        emoji: '📧',
        group: 'o'
    },
    {
        title: 'Incoming Envelope',
        emoji: '📨',
        group: 'o'
    },
    {
        title: 'Envelope with Arrow',
        emoji: '📩',
        group: 'o'
    },
    {
        title: 'Outbox Tray',
        emoji: '📤',
        group: 'o'
    },
    {
        title: 'Inbox Tray',
        emoji: '📥',
        group: 'o'
    },
    {
        title: 'Package',
        emoji: '📦',
        group: 'o'
    },
    {
        title: 'Closed Mailbox with Raised Flag',
        emoji: '📫',
        group: 'o'
    },
    {
        title: 'Closed Mailbox with Lowered Flag',
        emoji: '📪',
        group: 'o'
    },
    {
        title: 'Open Mailbox with Raised Flag',
        emoji: '📬',
        group: 'o'
    },
    {
        title: 'Open Mailbox with Lowered Flag',
        emoji: '📭',
        group: 'o'
    },
    {
        title: 'Postbox',
        emoji: '📮',
        group: 'o'
    },
    {
        title: 'Pencil',
        emoji: '✏️',
        group: 'o'
    },
    {
        title: 'Black Nib',
        emoji: '✒️',
        group: 'o'
    },
    {
        title: 'Memo',
        group: 'o',
        emoji: '📝'
    },
    {
        title: 'Briefcase',
        emoji: '💼',
        group: 'p'
    },
    {
        title: 'File Folder',
        emoji: '📁',
        group: 'o'
    },
    {
        title: 'Open File Folder',
        emoji: '📂',
        group: 'o'
    },
    {
        title: 'Calendar',
        emoji: '📅',
        group: 'o'
    },
    {
        title: 'Tear-Off Calendar',
        emoji: '📆',
        group: 'o'
    },
    {
        title: 'Card Index',
        emoji: '📇',
        group: 'o'
    },
    {
        title: 'Chart Increasing',
        emoji: '📈',
        group: 'o'
    },
    {
        title: 'Chart Decreasing',
        emoji: '📉',
        group: 'o'
    },
    {
        title: 'Bar Chart',
        emoji: '📊',
        group: 'o'
    },
    {
        title: 'Clipboard',
        emoji: '📋',
        group: 'o'
    },
    {
        title: 'Pushpin',
        emoji: '📌',
        group: 'o'
    },
    {
        title: 'Round Pushpin',
        emoji: '📍',
        group: 'o'
    },
    {
        title: 'Paperclip',
        emoji: '📎',
        group: 'o'
    },
    {
        title: 'Straight Ruler',
        emoji: '📏',
        group: 'o'
    },
    {
        title: 'Triangular Ruler',
        emoji: '📐',
        group: 'o'
    },
    {
        title: 'Scissors',
        emoji: '✂️',
        group: 'o'
    },
    {
        title: 'Locked',
        emoji: '🔒',
        group: 'o'
    },
    {
        title: 'Unlocked',
        emoji: '🔓',
        group: 'o'
    },
    {
        title: 'Locked with Pen',
        emoji: '🔏',
        group: 'o'
    },
    {
        title: 'Locked with Key',
        emoji: '🔐',
        group: 'o'
    },
    {
        title: 'Key',
        group: 'o',
        emoji: '🔑'
    },
    {
        title: 'Hammer',
        emoji: '🔨',
        group: 'o'
    },
    {
        title: 'Water Pistol',
        emoji: '🔫',
        group: 'o'
    },
    {
        title: 'Wrench',
        emoji: '🔧',
        group: 'o'
    },
    {
        title: 'Nut and Bolt',
        emoji: '🔩',
        group: 'o'
    },
    {
        title: 'Link',
        group: 'o',
        emoji: '🔗'
    },
    {
        title: 'Microscope',
        emoji: '🔬',
        group: 'o'
    },
    {
        title: 'Telescope',
        emoji: '🔭',
        group: 'o'
    },
    {
        title: 'Satellite Antenna',
        emoji: '📡',
        group: 'o'
    },
    {
        title: 'Syringe',
        emoji: '💉',
        group: 'o'
    },
    {
        title: 'Pill',
        group: 'o',
        emoji: '💊'
    },
    {
        title: 'Door',
        group: 'o',
        emoji: '🚪'
    },
    {
        title: 'Toilet',
        emoji: '🚽',
        group: 'o'
    },
    {
        title: 'Shower',
        emoji: '🚿',
        group: 'o'
    },
    {
        title: 'Bathtub',
        emoji: '🛁',
        group: 'o'
    },
    {
        title: 'Cigarette',
        emoji: '🚬',
        group: 'o'
    },
    {
        title: 'Moai',
        group: 'o',
        emoji: '🗿'
    },
    {
        title: 'ATM Sign',
        emoji: '🏧',
        group: 's'
    },
    {
        title: 'Litter in Bin Sign',
        emoji: '🚮',
        group: 's'
    },
    {
        title: 'Potable Water',
        emoji: '🚰',
        group: 'o'
    },
    {
        title: 'Wheelchair Symbol',
        emoji: '♿',
        group: 's'
    },
    {
        title: 'Men’s Room',
        emoji: '🚹',
        group: 's'
    },
    {
        title: 'Women’s Room',
        emoji: '🚺',
        group: 's'
    },
    {
        title: 'Restroom',
        emoji: '🚻',
        group: 's'
    },
    {
        title: 'Baby Symbol',
        emoji: '🚼',
        group: 's'
    },
    {
        title: 'Water Closet',
        emoji: '🚾',
        group: 's'
    },
    {
        title: 'Passport Control',
        emoji: '🛂',
        group: 't'
    },
    {
        title: 'Customs',
        emoji: '🛃',
        group: 't'
    },
    {
        title: 'Baggage Claim',
        emoji: '🛄',
        group: 't'
    },
    {
        title: 'Left Luggage',
        emoji: '🛅',
        group: 't'
    },
    {
        title: 'Warning',
        emoji: '⚠️',
        group: 's'
    },
    {
        title: 'Children Crossing',
        emoji: '🚸',
        group: 's'
    },
    {
        title: 'No Entry',
        emoji: '⛔',
        group: 's'
    },
    {
        title: 'Prohibited',
        emoji: '🚫',
        group: 's'
    },
    {
        title: 'No Bicycles',
        emoji: '🚳',
        group: 's'
    },
    {
        title: 'No Smoking',
        emoji: '🚭',
        group: 's'
    },
    {
        title: 'No Littering',
        emoji: '🚯',
        group: 's'
    },
    {
        title: 'Non-Potable Water',
        emoji: '🚱',
        group: 's'
    },
    {
        title: 'No Pedestrians',
        emoji: '🚷',
        group: 's'
    },
    {
        title: 'No Mobile Phones',
        emoji: '📵',
        group: 's'
    },
    {
        title: 'No One Under Eighteen',
        emoji: '🔞',
        group: 's'
    },
    {
        title: 'Up Arrow',
        emoji: '⬆️',
        group: 's'
    },
    {
        title: 'Up-Right Arrow',
        emoji: '↗️',
        group: 's'
    },
    {
        title: 'Right Arrow',
        emoji: '➡️',
        group: 's'
    },
    {
        title: 'Down-Right Arrow',
        emoji: '↘️',
        group: 's'
    },
    {
        title: 'Down Arrow',
        emoji: '⬇️',
        group: 's'
    },
    {
        title: 'Down-Left Arrow',
        emoji: '↙️',
        group: 's'
    },
    {
        title: 'Left Arrow',
        emoji: '⬅️',
        group: 's'
    },
    {
        title: 'Up-Left Arrow',
        emoji: '↖️',
        group: 's'
    },
    {
        title: 'Up-Down Arrow',
        emoji: '↕️',
        group: 's'
    },
    {
        title: 'Left-Right Arrow',
        emoji: '↔️',
        group: 's'
    },
    {
        title: 'Right Arrow Curving Left',
        emoji: '↩️',
        group: 's'
    },
    {
        title: 'Left Arrow Curving Right',
        emoji: '↪️',
        group: 's'
    },
    {
        title: 'Right Arrow Curving Up',
        emoji: '⤴️',
        group: 's'
    },
    {
        title: 'Right Arrow Curving Down',
        emoji: '⤵️',
        group: 's'
    },
    {
        title: 'Clockwise Vertical Arrows',
        emoji: '🔃',
        group: 's'
    },
    {
        title: 'Counterclockwise Arrows Button',
        emoji: '🔄',
        group: 's'
    },
    {
        title: 'Back Arrow',
        emoji: '🔙',
        group: 's'
    },
    {
        title: 'End Arrow',
        emoji: '🔚',
        group: 's'
    },
    {
        title: 'On! Arrow',
        emoji: '🔛',
        group: 's'
    },
    {
        title: 'Soon Arrow',
        emoji: '🔜',
        group: 's'
    },
    {
        title: 'Top Arrow',
        emoji: '🔝',
        group: 's'
    },
    {
        title: 'Dotted Six-Pointed Star',
        emoji: '🔯',
        group: 's'
    },
    {
        title: 'Aries',
        emoji: '♈',
        group: 's'
    },
    {
        title: 'Taurus',
        emoji: '♉',
        group: 's'
    },
    {
        title: 'Gemini',
        emoji: '♊',
        group: 's'
    },
    {
        title: 'Cancer',
        emoji: '♋',
        group: 's'
    },
    {
        title: 'Leo',
        group: 's',
        emoji: '♌'
    },
    {
        title: 'Virgo',
        emoji: '♍',
        group: 's'
    },
    {
        title: 'Libra',
        emoji: '♎',
        group: 's'
    },
    {
        title: 'Scorpio',
        emoji: '♏',
        group: 's'
    },
    {
        title: 'Sagittarius',
        emoji: '♐',
        group: 's'
    },
    {
        title: 'Capricorn',
        emoji: '♑',
        group: 's'
    },
    {
        title: 'Aquarius',
        emoji: '♒',
        group: 's'
    },
    {
        title: 'Pisces',
        emoji: '♓',
        group: 's'
    },
    {
        title: 'Ophiuchus',
        emoji: '⛎',
        group: 's'
    },
    {
        title: 'Shuffle Tracks Button',
        emoji: '🔀',
        group: 's'
    },
    {
        title: 'Repeat Button',
        emoji: '🔁',
        group: 's'
    },
    {
        title: 'Repeat Single Button',
        emoji: '🔂',
        group: 's'
    },
    {
        title: 'Play Button',
        emoji: '▶️',
        group: 's'
    },
    {
        title: 'Fast-Forward Button',
        emoji: '⏩',
        group: 's'
    },
    {
        title: 'Reverse Button',
        emoji: '◀️',
        group: 's'
    },
    {
        title: 'Fast Reverse Button',
        emoji: '⏪',
        group: 's'
    },
    {
        title: 'Upwards Button',
        emoji: '🔼',
        group: 's'
    },
    {
        title: 'Fast Up Button',
        emoji: '⏫',
        group: 's'
    },
    {
        title: 'Downwards Button',
        emoji: '🔽',
        group: 's'
    },
    {
        title: 'Fast Down Button',
        emoji: '⏬',
        group: 's'
    },
    {
        title: 'Cinema',
        emoji: '🎦',
        group: 's'
    },
    {
        title: 'Dim Button',
        emoji: '🔅',
        group: 's'
    },
    {
        title: 'Bright Button',
        emoji: '🔆',
        group: 's'
    },
    {
        title: 'Antenna Bars',
        emoji: '📶',
        group: 's'
    },
    {
        title: 'Vibration Mode',
        emoji: '📳',
        group: 's'
    },
    {
        title: 'Mobile Phone Off',
        emoji: '📴',
        group: 's'
    },
    {
        title: 'Multiply',
        emoji: '✖️',
        group: 's'
    },
    {
        title: 'Plus',
        group: 's',
        emoji: '➕'
    },
    {
        title: 'Minus',
        emoji: '➖',
        group: 's'
    },
    {
        title: 'Divide',
        emoji: '➗',
        group: 's'
    },
    {
        title: 'Double Exclamation Mark',
        emoji: '‼️',
        group: 's'
    },
    {
        title: 'Exclamation Question Mark',
        emoji: '⁉️',
        group: 's'
    },
    {
        title: 'Red Question Mark',
        emoji: '❓',
        group: 's'
    },
    {
        title: 'White Question Mark',
        emoji: '❔',
        group: 's'
    },
    {
        title: 'White Exclamation Mark',
        emoji: '❕',
        group: 's'
    },
    {
        title: 'Red Exclamation Mark',
        emoji: '❗',
        group: 's'
    },
    {
        title: 'Wavy Dash',
        emoji: '〰️',
        group: 's'
    },
    {
        title: 'Currency Exchange',
        emoji: '💱',
        group: 's'
    },
    {
        title: 'Heavy Dollar Sign',
        emoji: '💲',
        group: 's'
    },
    {
        title: 'Recycling Symbol',
        emoji: '♻️',
        group: 's'
    },
    {
        title: 'Trident Emblem',
        emoji: '🔱',
        group: 's'
    },
    {
        title: 'Name Badge',
        emoji: '📛',
        group: 's'
    },
    {
        title: 'Japanese Symbol for Beginner',
        emoji: '🔰',
        group: 's'
    },
    {
        title: 'Hollow Red Circle',
        emoji: '⭕',
        group: 's'
    },
    {
        title: 'Check Mark Button',
        emoji: '✅',
        group: 's'
    },
    {
        title: 'Check Box with Check',
        emoji: '☑️',
        group: 's'
    },
    {
        title: 'Check Mark',
        emoji: '✔️',
        group: 's'
    },
    {
        title: 'Cross Mark',
        emoji: '❌',
        group: 's'
    },
    {
        title: 'Cross Mark Button',
        emoji: '❎',
        group: 's'
    },
    {
        title: 'Curly Loop',
        emoji: '➰',
        group: 's'
    },
    {
        title: 'Double Curly Loop',
        emoji: '➿',
        group: 's'
    },
    {
        title: 'Part Alternation Mark',
        emoji: '〽️',
        group: 's'
    },
    {
        title: 'Eight-Spoked Asterisk',
        emoji: '✳️',
        group: 's'
    },
    {
        title: 'Eight-Pointed Star',
        emoji: '✴️',
        group: 's'
    },
    {
        title: 'Sparkle',
        emoji: '❇️',
        group: 's'
    },
    {
        title: 'Keycap Number Sign',
        emoji: '#️⃣',
        group: 's'
    },
    {
        title: 'Keycap Digit Zero',
        emoji: '0️⃣',
        group: 's'
    },
    {
        title: 'Keycap Digit One',
        emoji: '1️⃣',
        group: 's'
    },
    {
        title: 'Keycap Digit Two',
        emoji: '2️⃣',
        group: 's'
    },
    {
        title: 'Keycap Digit Three',
        emoji: '3️⃣',
        group: 's'
    },
    {
        title: 'Keycap Digit Four',
        emoji: '4️⃣',
        group: 's'
    },
    {
        title: 'Keycap Digit Five',
        emoji: '5️⃣',
        group: 's'
    },
    {
        title: 'Keycap Digit Six',
        emoji: '6️⃣',
        group: 's'
    },
    {
        title: 'Keycap Digit Seven',
        emoji: '7️⃣',
        group: 's'
    },
    {
        title: 'Keycap Digit Eight',
        emoji: '8️⃣',
        group: 's'
    },
    {
        title: 'Keycap Digit Nine',
        emoji: '9️⃣',
        group: 's'
    },
    {
        title: 'Keycap: 10',
        group: 's',
        emoji: '🔟'
    },
    {
        title: 'Input Latin Uppercase',
        emoji: '🔠',
        group: 's'
    },
    {
        title: 'Input Latin Lowercase',
        emoji: '🔡',
        group: 's'
    },
    {
        title: 'Input Numbers',
        emoji: '🔢',
        group: 's'
    },
    {
        title: 'Input Symbols',
        emoji: '🔣',
        group: 's'
    },
    {
        title: 'Input Latin Letters',
        emoji: '🔤',
        group: 's'
    },
    {
        title: 'A Button (Blood Type)',
        emoji: '🅰️',
        group: 's'
    },
    {
        title: 'AB Button (Blood Type)',
        emoji: '🆎',
        group: 's'
    },
    {
        title: 'B Button (Blood Type)',
        emoji: '🅱️',
        group: 's'
    },
    {
        title: 'CL Button',
        emoji: '🆑',
        group: 's'
    },
    {
        title: 'Cool Button',
        emoji: '🆒',
        group: 's'
    },
    {
        title: 'Free Button',
        emoji: '🆓',
        group: 's'
    },
    {
        title: 'Information',
        emoji: 'ℹ️',
        group: 's'
    },
    {
        title: 'ID Button',
        emoji: '🆔',
        group: 's'
    },
    {
        title: 'Circled M',
        emoji: 'Ⓜ️',
        group: 's'
    },
    {
        title: 'New Button',
        emoji: '🆕',
        group: 's'
    },
    {
        title: 'NG Button',
        emoji: '🆖',
        group: 's'
    },
    {
        title: 'O Button (Blood Type)',
        emoji: '🅾️',
        group: 's'
    },
    {
        title: 'OK Button',
        emoji: '🆗',
        group: 's'
    },
    {
        title: 'P Button',
        emoji: '🅿️',
        group: 's'
    },
    {
        title: 'SOS Button',
        emoji: '🆘',
        group: 's'
    },
    {
        title: 'Up! Button',
        emoji: '🆙',
        group: 's'
    },
    {
        title: 'Vs Button',
        emoji: '🆚',
        group: 's'
    },
    {
        title: 'Japanese “Here” Button',
        emoji: '🈁',
        group: 's'
    },
    {
        title: 'Japanese “Service Charge” Button',
        emoji: '🈂️',
        group: 's'
    },
    {
        title: 'Japanese “Monthly Amount” Button',
        emoji: '🈷️',
        group: 's'
    },
    {
        title: 'Japanese “Not Free of Charge” Button',
        emoji: '🈶',
        group: 's'
    },
    {
        title: 'Japanese “Reserved” Button',
        emoji: '🈯',
        group: 's'
    },
    {
        title: 'Japanese “Bargain” Button',
        emoji: '🉐',
        group: 's'
    },
    {
        title: 'Japanese “Discount” Button',
        emoji: '🈹',
        group: 's'
    },
    {
        title: 'Japanese “Free of Charge” Button',
        emoji: '🈚',
        group: 's'
    },
    {
        title: 'Japanese “Prohibited” Button',
        emoji: '🈲',
        group: 's'
    },
    {
        title: 'Japanese “Acceptable” Button',
        emoji: '🉑',
        group: 's'
    },
    {
        title: 'Japanese “Application” Button',
        emoji: '🈸',
        group: 's'
    },
    {
        title: 'Japanese “Passing Grade” Button',
        emoji: '🈴',
        group: 's'
    },
    {
        title: 'Japanese “Vacancy” Button',
        emoji: '🈳',
        group: 's'
    },
    {
        title: 'Japanese “Congratulations” Button',
        emoji: '㊗️',
        group: 's'
    },
    {
        title: 'Japanese “Secret” Button',
        emoji: '㊙️',
        group: 's'
    },
    {
        title: 'Japanese “Open for Business” Button',
        emoji: '🈺',
        group: 's'
    },
    {
        title: 'Japanese “No Vacancy” Button',
        emoji: '🈵',
        group: 's'
    },
    {
        title: 'Red Circle',
        emoji: '🔴',
        group: 's'
    },
    {
        title: 'Blue Circle',
        emoji: '🔵',
        group: 's'
    },
    {
        title: 'Black Circle',
        emoji: '⚫',
        group: 's'
    },
    {
        title: 'White Circle',
        emoji: '⚪',
        group: 's'
    },
    {
        title: 'Black Large Square',
        emoji: '⬛',
        group: 's'
    },
    {
        title: 'White Large Square',
        emoji: '⬜',
        group: 's'
    },
    {
        title: 'Black Medium Square',
        emoji: '◼️',
        group: 's'
    },
    {
        title: 'White Medium Square',
        emoji: '◻️',
        group: 's'
    },
    {
        title: 'Black Medium-Small Square',
        emoji: '◾',
        group: 's'
    },
    {
        title: 'White Medium-Small Square',
        emoji: '◽',
        group: 's'
    },
    {
        title: 'Black Small Square',
        emoji: '▪️',
        group: 's'
    },
    {
        title: 'White Small Square',
        emoji: '▫️',
        group: 's'
    },
    {
        title: 'Large Orange Diamond',
        emoji: '🔶',
        group: 's'
    },
    {
        title: 'Large Blue Diamond',
        emoji: '🔷',
        group: 's'
    },
    {
        title: 'Small Orange Diamond',
        emoji: '🔸',
        group: 's'
    },
    {
        title: 'Small Blue Diamond',
        emoji: '🔹',
        group: 's'
    },
    {
        title: 'Red Triangle Pointed Up',
        emoji: '🔺',
        group: 's'
    },
    {
        title: 'Red Triangle Pointed Down',
        emoji: '🔻',
        group: 's'
    },
    {
        title: 'Diamond with a Dot',
        emoji: '💠',
        group: 's'
    },
    {
        title: 'Radio Button',
        emoji: '🔘',
        group: 's'
    },
    {
        title: 'White Square Button',
        emoji: '🔳',
        group: 's'
    },
    {
        title: 'Black Square Button',
        emoji: '🔲',
        group: 's'
    },
    {
        title: 'Chequered Flag',
        emoji: '🏁',
        group: 'fl'
    },
    {
        title: 'Triangular Flag',
        emoji: '🚩',
        group: 'fl'
    },
    {
        title: 'Crossed Flags',
        emoji: '🎌',
        group: 'fl'
    },
];